/* tslint:disable */
/* eslint-disable */
/* @relayHash ed01b1be6331b718650a9743bd997620 */

import { ConcreteRequest } from "relay-runtime";
export type CancelAccountDeletionInput = {
    clientMutationId: string;
};
export type CancelAccountDeletionMutationVariables = {
    input: CancelAccountDeletionInput;
};
export type CancelAccountDeletionMutationResponse = {
    readonly cancelAccountDeletion: {
        readonly user: {
            readonly scheduledDeletionDate: string | null;
        };
        readonly clientMutationId: string;
    };
};
export type CancelAccountDeletionMutation = {
    readonly response: CancelAccountDeletionMutationResponse;
    readonly variables: CancelAccountDeletionMutationVariables;
};



/*
mutation CancelAccountDeletionMutation(
  $input: CancelAccountDeletionInput!
) {
  cancelAccountDeletion(input: $input) {
    user {
      scheduledDeletionDate
      id
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scheduledDeletionDate",
        "storageKey": null
    } as any), v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CancelAccountDeletionMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CancelAccountDeletionPayload",
                    "kind": "LinkedField",
                    "name": "cancelAccountDeletion",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CancelAccountDeletionMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CancelAccountDeletionPayload",
                    "kind": "LinkedField",
                    "name": "cancelAccountDeletion",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "ed01b1be6331b718650a9743bd997620",
            "metadata": {},
            "name": "CancelAccountDeletionMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '0c74ec932147e88685fad7887c597a7a';
export default node;
